import React from 'react';

export const Logo = ({ size = 36 }) => (
  <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
    <div style={{ width: size, height: size, background: 'var(--green)', borderRadius: size * 0.25, display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0 }}>
      <svg width={size * 0.55} height={size * 0.55} viewBox="0 0 22 22" fill="none">
        <path d="M11 2C6.1 2 2 6.1 2 11C2 12.8 2.5 14.5 3.4 15.9L2 20L6.2 18.6C7.6 19.5 9.2 20 11 20C15.9 20 20 15.9 20 11C20 6.1 15.9 2 11 2Z" fill="white"/>
        <circle cx="7.5" cy="11" r="1.5" fill="#00E74C"/>
        <circle cx="11" cy="11" r="1.5" fill="#00E74C"/>
        <circle cx="14.5" cy="11" r="1.5" fill="#00E74C"/>
      </svg>
    </div>
    <div style={{ lineHeight: 1 }}>
      <div style={{ fontFamily: 'Sora', fontWeight: 800, fontSize: size * 0.5 }}>
        <span style={{ color: 'var(--green)' }}>MS</span>
        <span style={{ color: '#ffffff' }}>Reach</span>
      </div>
      <div style={{ fontSize: 9, color: 'rgba(255,255,255,0.3)', letterSpacing: 1.5, marginTop: 2 }}>BY MS DISCOVERIES</div>
    </div>
  </div>
);

export const Btn = ({ children, variant = 'primary', size = 'md', onClick, disabled, style, type = 'button', full }) => {
  const styles = {
    primary: { background: 'var(--green)', color: '#000', border: 'none' },
    outline: { background: 'transparent', color: '#ffffff', border: '1px solid rgba(255,255,255,0.2)' },
    ghost:   { background: 'transparent', color: 'rgba(255,255,255,0.6)', border: 'none' },
    danger:  { background: 'rgba(255,68,68,0.1)', color: '#ff6b6b', border: '1px solid rgba(255,68,68,0.2)' },
    success: { background: 'rgba(0,231,76,0.1)', color: 'var(--green)', border: '1px solid rgba(0,231,76,0.2)' },
  };
  const sizes = {
    sm: { padding: '6px 12px', fontSize: 12, borderRadius: 6 },
    md: { padding: '10px 20px', fontSize: 14, borderRadius: 8 },
    lg: { padding: '13px 28px', fontSize: 15, borderRadius: 10 },
  };
  return (
    <button type={type} onClick={onClick} disabled={disabled} style={{ ...styles[variant], ...sizes[size], fontFamily: 'Sora', fontWeight: 600, cursor: disabled ? 'not-allowed' : 'pointer', opacity: disabled ? 0.6 : 1, transition: 'all 0.2s', width: full ? '100%' : 'auto', display: 'inline-flex', alignItems: 'center', justifyContent: 'center', gap: 6, ...style }}>
      {children}
    </button>
  );
};

export const Input = ({ label, type = 'text', value, onChange, placeholder, required, style }) => (
  <div style={{ marginBottom: 16 }}>
    {label && <label style={{ display: 'block', fontSize: 13, color: 'rgba(255,255,255,0.6)', marginBottom: 6, fontWeight: 500 }}>{label}{required && ' *'}</label>}
    <input type={type} value={value} onChange={onChange} placeholder={placeholder} required={required} style={{ width: '100%', background: 'rgba(255,255,255,0.04)', border: '1px solid rgba(255,255,255,0.1)', borderRadius: 8, padding: '11px 14px', color: '#ffffff', fontSize: 14, outline: 'none', transition: 'border-color 0.2s', ...style }}
      onFocus={e => e.target.style.borderColor = 'var(--green)'}
      onBlur={e => e.target.style.borderColor = 'rgba(255,255,255,0.1)'}
    />
  </div>
);

export const Select = ({ label, value, onChange, options, required, style }) => (
  <div style={{ marginBottom: 16 }}>
    {label && <label style={{ display: 'block', fontSize: 13, color: 'rgba(255,255,255,0.6)', marginBottom: 6, fontWeight: 500 }}>{label}{required && ' *'}</label>}
    <select value={value} onChange={onChange} required={required} style={{ width: '100%', background: 'rgba(255,255,255,0.04)', border: '1px solid rgba(255,255,255,0.1)', borderRadius: 8, padding: '11px 14px', color: '#ffffff', fontSize: 14, outline: 'none', ...style }}>
      {options.map(opt => <option key={opt.value} value={opt.value} style={{ background: '#161616', color: '#fff' }}>{opt.label}</option>)}
    </select>
  </div>
);

export const Card = ({ children, style, title }) => (
  <div style={{ background: 'var(--bg-card)', border: '1px solid var(--border)', borderRadius: 'var(--radius)', padding: 20, ...style }}>
    {title && <div style={{ fontSize: 13, fontWeight: 600, color: 'rgba(255,255,255,0.7)', marginBottom: 16 }}>{title}</div>}
    {children}
  </div>
);

export const Badge = ({ children, type = 'info' }) => {
  const colors = {
    success: { bg: 'rgba(0,231,76,0.12)', color: '#00E74C' },
    warning: { bg: 'rgba(255,215,0,0.12)', color: '#ffd700' },
    danger:  { bg: 'rgba(255,68,68,0.12)',  color: '#ff6b6b' },
    info:    { bg: 'rgba(77,168,255,0.12)', color: '#4da8ff' },
  };
  const statusMap = { active:'success', approved:'success', open:'info', paid:'success', pending:'warning', in_progress:'warning', suspended:'danger', blocked:'danger', rejected:'danger', closed:'success', new:'info', contacted:'info', interested:'warning', negotiation:'warning', hot:'danger', warm:'warning', cold:'info', customer:'success' };
  const resolvedType = statusMap[children?.toLowerCase()] || type;
  const { bg, color } = colors[resolvedType] || colors.info;
  return <span style={{ background: bg, color, padding: '3px 10px', borderRadius: 100, fontSize: 11, fontWeight: 700, display: 'inline-block', textTransform: 'uppercase', letterSpacing: 0.5 }}>{children}</span>;
};

export const StatCard = ({ icon, value, label, color = 'var(--green)' }) => (
  <div style={{ background: 'var(--bg-card)', border: '1px solid var(--border)', borderRadius: 'var(--radius)', padding: '18px 20px', display: 'flex', alignItems: 'center', gap: 14 }}>
    <div style={{ fontSize: 26 }}>{icon}</div>
    <div>
      <div style={{ fontSize: 22, fontWeight: 700, fontFamily: 'Sora', color }}>{value}</div>
      <div style={{ fontSize: 12, color: 'rgba(255,255,255,0.4)', marginTop: 2 }}>{label}</div>
    </div>
  </div>
);

export const Modal = ({ open, onClose, title, children, width = 480 }) => {
  if (!open) return null;
  return (
    <div onClick={onClose} style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.85)', zIndex: 9999, display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 24 }}>
      <div onClick={e => e.stopPropagation()} style={{ background: '#161616', border: '1px solid rgba(255,255,255,0.1)', borderRadius: 16, padding: 36, width: '100%', maxWidth: width, animation: 'fadeIn 0.2s ease' }}>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 20 }}>
          <h2 style={{ fontSize: 20, fontFamily: 'Sora', fontWeight: 700, color: '#fff' }}>{title}</h2>
          <button onClick={onClose} style={{ background: 'rgba(255,255,255,0.06)', border: '1px solid rgba(255,255,255,0.1)', color: 'rgba(255,255,255,0.5)', width: 32, height: 32, borderRadius: '50%', cursor: 'pointer', fontSize: 14 }}>✕</button>
        </div>
        {children}
      </div>
    </div>
  );
};

export const Table = ({ columns, data, loading, emptyMsg = 'No data found' }) => (
  <div style={{ overflowX: 'auto' }}>
    <table style={{ width: '100%', borderCollapse: 'collapse' }}>
      <thead>
        <tr>
          {columns.map(col => (
            <th key={col.key} style={{ background: 'rgba(255,255,255,0.03)', padding: '10px 14px', textAlign: 'left', fontSize: 11, fontWeight: 600, color: 'rgba(255,255,255,0.4)', textTransform: 'uppercase', letterSpacing: 0.5, borderBottom: '1px solid var(--border)' }}>{col.label}</th>
          ))}
        </tr>
      </thead>
      <tbody>
        {loading ? (
          <tr><td colSpan={columns.length} style={{ textAlign: 'center', padding: 32, color: 'rgba(255,255,255,0.3)', fontSize: 14 }}>Loading...</td></tr>
        ) : data.length === 0 ? (
          <tr><td colSpan={columns.length} style={{ textAlign: 'center', padding: 40, color: 'rgba(255,255,255,0.3)', fontSize: 14 }}>{emptyMsg}</td></tr>
        ) : data.map((row, i) => (
          <tr key={i} style={{ borderBottom: '1px solid var(--border)' }} onMouseOver={e => e.currentTarget.style.background = 'rgba(255,255,255,0.02)'} onMouseOut={e => e.currentTarget.style.background = 'transparent'}>
            {columns.map(col => (
              <td key={col.key} style={{ padding: '12px 14px', fontSize: 13, color: '#ffffff' }}>
                {col.render ? col.render(row[col.key], row) : row[col.key] || '—'}
              </td>
            ))}
          </tr>
        ))}
      </tbody>
    </table>
  </div>
);

export const Spinner = ({ size = 24 }) => (
  <div style={{ width: size, height: size, border: `2px solid rgba(255,255,255,0.1)`, borderTop: `2px solid var(--green)`, borderRadius: '50%', animation: 'spin 0.8s linear infinite', display: 'inline-block' }} />
);

export const Empty = ({ icon = '📭', title, desc, action }) => (
  <div style={{ textAlign: 'center', padding: '60px 20px' }}>
    <div style={{ fontSize: 48, marginBottom: 16 }}>{icon}</div>
    {title && <h3 style={{ marginBottom: 8, fontFamily: 'Sora', color: '#fff' }}>{title}</h3>}
    {desc && <p style={{ color: 'rgba(255,255,255,0.4)', fontSize: 14, marginBottom: action ? 24 : 0 }}>{desc}</p>}
    {action}
  </div>
);

export const PageHeader = ({ title, action }) => (
  <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: 24, paddingBottom: 16, borderBottom: '1px solid var(--border)' }}>
    <h1 style={{ fontSize: 20, fontWeight: 700, fontFamily: 'Sora', color: '#ffffff' }}>{title}</h1>
    {action}
  </div>
);
